import {useIntl} from 'react-intl'

interface FilterDrawerProps {
  open: boolean
  setOpen: (open: boolean) => void
  filter: any
  setFilter: (filter: any) => void
  search: string
  setSearch: (search: string) => void
  status: string
  setStatus: (status: string) => void
}

export default function FilterDrawer({
  open,
  setOpen,
  filter,
  setFilter,
  search,
  setSearch,
  status,
  setStatus,
}: FilterDrawerProps) {
  const intl = useIntl()

  const submitFilter = (value: string) => {
    setFilter([
      {
        key: 'nm',
        operator: 14,
        logicalOp: 2,
        value: [value],
        childFilters: [
          {
            key: 'SkuID',
            operator: 14,
            logicalOp: 2,
            value: [value],
            childFilters: [],
          },
          {
            key: 'brcd',
            operator: 14,
            logicalOp: 2,
            value: [value],
            childFilters: [],
          },
        ],
      },
      // {
      //   key: 'stts',
      //   value: [status],
      //   operator: 1,
      //   logicalOp: 2,
      // },
      ...(status !== '0' ? [{key: 'stts', value: [status], operator: 1, logicalOp: 2}] : []),
    ])
    setOpen(false)
  }

  return (
    <>
      {open && <div className='drawer-overlay' onClick={() => setOpen(false)}></div>}
      <div
        className={`bg-body custom-drawer drawer drawer-end ${open ? 'drawer-on' : ''}`}
        // style={{width: '525px'}}
        // default width: 350px md: 525px style
        // id='kt_filter'
        // className='bg-body'
        // data-kt-drawer='true'
        // data-kt-drawer-name='filter'
        // data-kt-drawer-activate='true'
        // data-kt-drawer-overlay='true'
        // data-kt-drawer-width="{default:'350px', 'md': '525px'}"
        // data-kt-drawer-direction='end'
        // data-kt-drawer-toggle='#kt_filter_toggle'
        // data-kt-drawer-close='#kt_filter_close'
      >
        <div className='card rounded-0 w-100'>
          <div className='card-header pe-5'>
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1'>
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SELECTED'})}
                </span>
              </div>
            </div>

            <div className='card-toolbar'>
              <button
                className='btn btn-sm btn-icon btn-active-light-primary'
                // id='kt_filter_close'
                onClick={() => {
                  setOpen(false)
                }}
              >
                <span className='svg-icon svg-icon-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <rect
                      opacity='0.5'
                      x='6'
                      y='17.3137'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(-45 6 17.3137)'
                      fill='black'
                    ></rect>
                    <rect
                      x='7.41422'
                      y='6'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(45 7.41422 6)'
                      fill='black'
                    ></rect>
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <div className='card-body hover-scroll-overlay-y'>
            <form id='filterForm'>
              <div className='px-7 py-5'>
                <div className='mb-5'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH'})}:
                  </label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <input
                        className='form-control mr-sm-2'
                        type='search'
                        placeholder={intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH.PRODUCT'})}
                        aria-label='Search'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                            submitFilter(e.currentTarget.value)
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className='mb-5 flex'>
                  {allFilter().map((item, index) => (
                    <span className="badge badge-primary" style={{ marginRight: 5 }} key={index}>
                      {filterTypes.find((type) => type.key === item.key)?.label}

                      <span
                        style={{ marginLeft: 5 }}
                        className="cursor-pointer"
                        onClick={() => {
                          const newFilters = [...filters];
                          newFilters.splice(index, 1);
                          setFilters(newFilters);
                        }}
                      >
                        <i className="bi bi-x-circle-fill"></i>
                      </span>
                    </span>
                  ))}
                  <span
                    onClick={() => setShowFilter(!showFilter)}
                    className="badge badge-success cursor-pointer" style={{ marginLeft: 5 }}>
                    {showFilter ? 'Close New Filter' : 'Add Filter'}
                  </span>
                </div>

                {showFilter && (
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Filter Types:</label>

                    <div className='row'>
                      <div className='col-md-10 mb-4'>
                        <select
                          className='form-control form-select form-select-solid'
                          data-control='select2'
                          data-placeholder='Select an option'
                          data-allow-clear='true'
                          defaultValue="nm"
                          onChange={(e) => {
                            setFilterType({
                              ...filterType,
                              key: e.target.value
                            })
                          }}
                        >
                          {filterTypes.map((item, index) => (
                            <option value={item.key} key={index}>{item.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2 mb-4">
                        <span
                          className='btn btn-success cursor-pointer'
                          onClick={() => addFilter()}
                        >
                          Add
                        </span>
                      </div>
                    </div>
                  </div>
                )} */}

                <div className='mb-10'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'GLOBAL.FILTER.STATUS'})}:
                    :</label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <select
                        className='form-control form-select form-select-solid'
                        data-control='select2'
                        data-placeholder='Select an option'
                        data-allow-clear='true'
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        {/* <option value='0'>All</option>
                        <option value='1'>Active</option>
                        <option value='2'>Inactive</option> */}
                        <option value='0'>{intl.formatMessage({id: 'GLOBAL.FILTER.ALL'})}</option>
                        <option value='1'>{intl.formatMessage({id: 'GLOBAL.FILTER.ACTIVE'})}</option>
                        <option value='2'>{intl.formatMessage({id: 'GLOBAL.FILTER.INACTIVE'})}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className='card-footer'>
            <div className='row'>
              <div className='col-md-6'>
                <button
                  type='reset'
                  className='btn w-100 btn-sm btn-light-danger'
                  onClick={() => {
                    setSearch('')
                    submitFilter('')
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.CLEAR'})}
                </button>
              </div>
              <div className='col-md-6'>
                <button
                  className='btn w-100 btn-sm btn-primary'
                  id='kt_filter_toggle'
                  onClick={() => {
                    submitFilter(search)
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
